import { useQuery } from '@tanstack/react-query'
import { useStores } from 'config/store'
import {
  getStaffListAverageHoldTime,
  Response,
} from 'services/calls/metrics/getStaffListAverageHoldTime'

export function useReactQuery(args: { enabled?: boolean } = {}) {
  const { enabled = true } = args
  const { dashboardUIStore, accountStore } = useStores()
  const accountIds = (accountStore.selectedAccounts || []).slice()
  const filters = dashboardUIStore.globalFiltersQuery
  const key = JSON.stringify({ filters, accountIds })

  return useQuery({
    enabled,
    queryKey: ['calls', 'metrics', 'staff-average-hold-time', key],
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
    placeholderData: { summary: {}, records: [] } as never as Response,
    queryFn: async ({ signal }) => {
      return getStaffListAverageHoldTime({ signal, accountIds, filters })
    },
  })
}
